export default __webpack_public_path__ + "static/media/tng-color.82a3da7f.svg";